export default __webpack_public_path__ + "static/MadePilar-f0de959602825a49a8f37796f4f53c51.jpg";